let initState = {
    isOnline: true
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'IS_ONLINE': {
            let copy = { ...state }
            if (action.payload) {
                if (action.payload !== copy.isOnline) {
                    return { ...state, isOnline: true, reload: true }
                } else {
                    return { ...state, isOnline: true, reload: false }
                }

            } else {
                return { ...state, isOnline: false }
            }
        }
        case 'KEEP_STATE': {
            return {
                ...state,
                keepState: action.payload,
            }
        }
        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js